import { render } from "./edit-test.vue?vue&type=template&id=6c17ea37"
import script from "./edit-test.vue?vue&type=script&lang=js"
export * from "./edit-test.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__